// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DigiLockerLanding_MainContainer__CZpGv{
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px;
    overflow-x: hidden;
    box-sizing: border-box;
}

.DigiLockerLanding_MainWrapper__LJoLi{
    border: 1px solid #ffaeae;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 0 15px 3px #817e7e1a;
    width: 90%;
    max-width: 800px;
    height: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.DigiLockerLanding_topPANDiv__G2lga{
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #e4e4e4;
    padding: 12px;
}

.DigiLockerLanding_topPanText__DZsMi{
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    color: #363636;
    margin-top: 5px;
    display: flex;
}

.DigiLockerLanding_topClockDiv__0\\+OAK{
    display: flex;
    gap: 5px;
    margin-top: 7px;
}

.DigiLockerLanding_clockIcon__SGVCM{
    height: 20px;
    width: 20px;
    align-self: center;
}

.DigiLockerLanding_clockText__WqAFa{
    font-size: 14px;
    color: #817E7E;
}

.DigiLockerLanding_tabsContainer__hRe-W {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    border-bottom: 1px solid #e4e4e4;
}

.DigiLockerLanding_tab__OnW2d {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    color: #817E7E;
    position: relative;
    transition: all 0.3s ease;
}

.DigiLockerLanding_activeTab__tEDKC {
    color: #f73439;
    font-weight: 500;
}

.DigiLockerLanding_activeTab__tEDKC::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #f73439;
}

.DigiLockerLanding_tabContent__fnuZ1 {
    padding: 20px 0;
}

.DigiLockerLanding_panDemoDiv__XUkWK{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 30px;
}

.DigiLockerLanding_EnterYourPan__D1x2y{
    font-family: 'CircularXXWeb-Medium';
    font-size: 16px;
    color: #040404CC;
}

.DigiLockerLanding_panImage__O4yAY{
    margin-top: 40px;
}

.DigiLockerLanding_SamplePANText__MjGt0{
    font-size: 12px;
    color: #817E7E;
    font-weight: 500;
}

.DigiLockerLanding_ListDiv__Fs5Cn{
    display: flex;
    flex-direction: column;
    padding: 0 15%;
    margin-top: 40px;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
}

.DigiLockerLanding_ListItem__dWM8x{
    align-items: center;
    margin-bottom: 10px;
    color: #4F4F4F;
    font-size: 12px;
    list-style-type: disc;
    list-style-position: outside;
}

.DigiLockerLanding_ListItem__dWM8x::marker {
    color: #ea9324;
    font-size: 1.2em;
}

.DigiLockerLanding_consentDiv__2gxGO{
    width: 70%;
    align-self: center;
    margin: 0 auto;
    font-size: 12px;
    color: #817E7E;
    line-height: 1.4;
    padding: 15px;
}

.DigiLockerLanding_shieldDiv__ditCr{
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    justify-content: center;
    margin-top: 50px;
    padding: 0 20px;
}

.DigiLockerLanding_shieldText__wkaYy{
    font-size: 14px;
    color: #404040BF;
    margin-left: 10px;
    padding: 5px;
}

.DigiLockerLanding_Line__sFD4P{
    border-bottom: 1px solid #e4e4e4;
    margin-top: 50px;
}

.DigiLockerLanding_verifyButton__SUkrs{
    background-image: linear-gradient(to top, #f73439, #f8777b) !important;
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    color: #fff;
    border-radius: 8px !important;
    border: none;
    cursor: pointer;
    padding: 8px 30px;
    margin: 10px auto;
    margin-left: 50%;
    transform: translate(-50%);
}

.DigiLockerLanding_addressFormContainer__tGyF0 {
    width: 100%;
    padding: 20px;
    max-width: 700px;
    margin: 0 auto;
}

.DigiLockerLanding_addressHeading__1dp53 {
    font-size: 16px;
    color: #363636;
    margin-bottom: 20px;
    text-align: center;
    font-weight: 500;
}

.DigiLockerLanding_formGroup__38QSX {
    margin-bottom: 20px;
    width: 100%;
}

.DigiLockerLanding_formLabel__UNLYd {
    display: block;
    font-size: 12px;
    color: #040404CC;
    margin-bottom: 5px;
}

.DigiLockerLanding_formInput__dB8FR {
    font-size: 14px;
    width: 100%;
    padding: 10px;
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    margin-top: 5px;
}

.DigiLockerLanding_formInput__dB8FR:focus {
    border-color: #f73439;
}

.DigiLockerLanding_formRow__pgOXK {
    display: flex;
    gap: 15px;
}

.DigiLockerLanding_formRow__pgOXK .DigiLockerLanding_formGroup__38QSX {
    flex: 1 1;
}

.DigiLockerLanding_uploadButton__fr9ue {
    background-color: #f73439;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    width: 100%;
    transition: background-color 0.3s ease;
}

.DigiLockerLanding_uploadButton__fr9ue:hover {
    background-color: #e41e23;
}

.DigiLockerLanding_documentUploadContainer__kH0Dh {
    width: 100%;
    margin-top: 10px;
}

.DigiLockerLanding_uploadSection__rQusV {
    display: flex;
    gap: 20px;
    justify-content: center;
    width: 100%;
}



.DigiLockerLanding_previewContainer__GclU9 {
    flex: 1 1;
    max-width: 450px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 20px;
    border: 1px dashed #e4e4e4;
    border-radius: 12px;
    transition: all 0.3s ease;
    background-color: #fafafa;
}

.DigiLockerLanding_previewContainer__GclU9:hover {
    border-color: #f73439;
    box-shadow: 0 2px 8px rgba(247, 52, 57, 0.1);
}

.DigiLockerLanding_previewImage__BsQF5 {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.DigiLockerLanding_uploadNote__IZy6t {
    font-size: 12px;
    color: #817E7E;
    margin-top: 10px;
    text-align: center;
}

.DigiLockerLanding_errorText__k5ioc {
    color: #f73439;
    font-size: 12px;
    margin-top: 5px;
    text-align: center;
}

.DigiLockerLanding_uploadButton__fr9ue:active {
    background-color: #f0f0f0;
}

.DigiLockerLanding_uploadNote__IZy6t {
    font-size: 12px;
    color: #817E7E;
    margin-top: 5px;
}

.DigiLockerLanding_errorText__k5ioc {
    color: #ffffff;
    font-size: 14px;
    margin-top: 10px;
    background-color: #f73439;
    padding: 12px 20px;
    border-radius: 8px;
    width: 100%;
    max-width: 600px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 2px 4px rgba(247, 52, 57, 0.2);
    animation: DigiLockerLanding_fadeIn__rF0aM 0.3s ease-in-out;
}

@keyframes DigiLockerLanding_fadeIn__rF0aM {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

.DigiLockerLanding_confirmationDiv__kcCSb{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2
}

.DigiLockerLanding_confirmationWrapper__SGuc6{
    background-color: #fff;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.DigiLockerLanding_confirmationItemDiv__EEr9P{
    width: 80%;
}

.DigiLockerLanding_loader__h5V0J{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2
}

.DigiLockerLanding_loaderDiv__huUei{
    background-color: #fff;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.DigiLockerLanding_fetchingText__r\\+P6F{
    margin-top: 50px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #040404CC;
    font-family: 'CircularXXWeb-Medium';
}

.DigiLockerLanding_loadingText__Zlsnb{
    color: #e78a00;
    font-size: 12px;
    text-align: center;
}


@media screen and (max-width: 768px) {
    .DigiLockerLanding_MainContainer__CZpGv {
        padding: 15px;
    }

    .DigiLockerLanding_topPanText__DZsMi {
        font-size: 16px;
    }

    .DigiLockerLanding_clockText__WqAFa {
        font-size: 12px;
    }

    .DigiLockerLanding_tab__OnW2d {
        padding: 8px 15px;
        font-size: 14px;
    }

    .DigiLockerLanding_EnterYourPan__D1x2y {
        font-size: 14px;
        margin-bottom: 40px;
        text-align: center;
        padding: 0 5px;
    }

    .DigiLockerLanding_ListDiv__Fs5Cn {
        padding: 0 5%;
        margin-top: 30px;
    }

    .DigiLockerLanding_consentDiv__2gxGO {
        width: 100%;
        font-size: 11px;
        padding: 15px;
        margin: 20px auto;
    }

    .DigiLockerLanding_verifyButton__SUkrs {
        width: 90%;
        max-width: 300px;
    }

    .DigiLockerLanding_shieldDiv__ditCr {
        padding: 0 15px;
        margin-top: 30px;
    }

    .DigiLockerLanding_shieldText__wkaYy {
        font-size: 13px;
    }

    .DigiLockerLanding_panImage__O4yAY {
        width: 100%;
        max-width: 400px;
        height: auto;
        margin-left: -15px;
        margin-top: 0;
    }

    .DigiLockerLanding_uploadSection__rQusV {
        flex-direction: column;
        align-items: center;
        gap: 30px;
    }
}

@media screen and (max-width: 480px) {
    .DigiLockerLanding_formRow__pgOXK {
        flex-direction: column;
        gap: 10px;
    }
}

.DigiLockerLanding_errorBanner__qCHV9 {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #fef2f2;
    border: 1.5px solid #f87171;
    color: #dc2626;
    padding: 12px 16px;
    border-radius: 10px;
    margin: 15px 0 5px 0;
    font-size: 13.5px;
    font-weight: 600;
    line-height: 1.4;
    text-align: left;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/organism/DigiLockerLanding.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,sEAAsE;IACtE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,WAAW;AACf;;;;AAIA;IACI,SAAO;IACP,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,4CAA4C;IAC5C,2DAAkC;AACtC;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,4CAA4C;AAChD","sourcesContent":[".MainContainer{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    overflow-x: hidden;\n    box-sizing: border-box;\n}\n\n.MainWrapper{\n    border: 1px solid #ffaeae;\n    border-radius: 20px;\n    background-color: #fff;\n    box-shadow: 0 0 15px 3px #817e7e1a;\n    width: 90%;\n    max-width: 800px;\n    height: 100%;\n    margin: 0 auto;\n    box-sizing: border-box;\n}\n\n.topPANDiv{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    border-bottom: 1px solid #e4e4e4;\n    padding: 12px;\n}\n\n.topPanText{\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 28px;\n    color: #363636;\n    margin-top: 5px;\n    display: flex;\n}\n\n.topClockDiv{\n    display: flex;\n    gap: 5px;\n    margin-top: 7px;\n}\n\n.clockIcon{\n    height: 20px;\n    width: 20px;\n    align-self: center;\n}\n\n.clockText{\n    font-size: 14px;\n    color: #817E7E;\n}\n\n.tabsContainer {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    border-bottom: 1px solid #e4e4e4;\n}\n\n.tab {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 16px;\n    color: #817E7E;\n    position: relative;\n    transition: all 0.3s ease;\n}\n\n.activeTab {\n    color: #f73439;\n    font-weight: 500;\n}\n\n.activeTab::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #f73439;\n}\n\n.tabContent {\n    padding: 20px 0;\n}\n\n.panDemoDiv{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    margin-top: 30px;\n}\n\n.EnterYourPan{\n    font-family: 'CircularXXWeb-Medium';\n    font-size: 16px;\n    color: #040404CC;\n}\n\n.panImage{\n    margin-top: 40px;\n}\n\n.SamplePANText{\n    font-size: 12px;\n    color: #817E7E;\n    font-weight: 500;\n}\n\n.ListDiv{\n    display: flex;\n    flex-direction: column;\n    padding: 0 15%;\n    margin-top: 40px;\n    max-width: 700px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.ListItem{\n    align-items: center;\n    margin-bottom: 10px;\n    color: #4F4F4F;\n    font-size: 12px;\n    list-style-type: disc;\n    list-style-position: outside;\n}\n\n.ListItem::marker {\n    color: #ea9324;\n    font-size: 1.2em;\n}\n\n.consentDiv{\n    width: 70%;\n    align-self: center;\n    margin: 0 auto;\n    font-size: 12px;\n    color: #817E7E;\n    line-height: 1.4;\n    padding: 15px;\n}\n\n.shieldDiv{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin: 0 auto;\n    justify-content: center;\n    margin-top: 50px;\n    padding: 0 20px;\n}\n\n.shieldText{\n    font-size: 14px;\n    color: #404040BF;\n    margin-left: 10px;\n    padding: 5px;\n}\n\n.Line{\n    border-bottom: 1px solid #e4e4e4;\n    margin-top: 50px;\n}\n\n.verifyButton{\n    background-image: linear-gradient(to top, #f73439, #f8777b) !important;\n    font-size: 16px;\n    font-weight: 400;\n    font-stretch: normal;\n    color: #fff;\n    border-radius: 8px !important;\n    border: none;\n    cursor: pointer;\n    padding: 8px 30px;\n    margin: 10px auto;\n    margin-left: 50%;\n    transform: translate(-50%);\n}\n\n.addressFormContainer {\n    width: 100%;\n    padding: 20px;\n    max-width: 700px;\n    margin: 0 auto;\n}\n\n.addressHeading {\n    font-size: 16px;\n    color: #363636;\n    margin-bottom: 20px;\n    text-align: center;\n    font-weight: 500;\n}\n\n.formGroup {\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.formLabel {\n    display: block;\n    font-size: 12px;\n    color: #040404CC;\n    margin-bottom: 5px;\n}\n\n.formInput {\n    font-size: 14px;\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #e4e4e4;\n    border-radius: 8px;\n    margin-top: 5px;\n}\n\n.formInput:focus {\n    border-color: #f73439;\n}\n\n.formRow {\n    display: flex;\n    gap: 15px;\n}\n\n.formRow .formGroup {\n    flex: 1;\n}\n\n.uploadButton {\n    background-color: #f73439;\n    color: white;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    width: 100%;\n    transition: background-color 0.3s ease;\n}\n\n.uploadButton:hover {\n    background-color: #e41e23;\n}\n\n.documentUploadContainer {\n    width: 100%;\n    margin-top: 10px;\n}\n\n.uploadSection {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    width: 100%;\n}\n\n\n\n.previewContainer {\n    flex: 1;\n    max-width: 450px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n    padding: 20px;\n    border: 1px dashed #e4e4e4;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n    background-color: #fafafa;\n}\n\n.previewContainer:hover {\n    border-color: #f73439;\n    box-shadow: 0 2px 8px rgba(247, 52, 57, 0.1);\n}\n\n.previewImage {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 16/9;\n    object-fit: cover;\n    border-radius: 8px;\n    margin-bottom: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.uploadNote {\n    font-size: 12px;\n    color: #817E7E;\n    margin-top: 10px;\n    text-align: center;\n}\n\n.errorText {\n    color: #f73439;\n    font-size: 12px;\n    margin-top: 5px;\n    text-align: center;\n}\n\n.uploadButton:active {\n    background-color: #f0f0f0;\n}\n\n.uploadNote {\n    font-size: 12px;\n    color: #817E7E;\n    margin-top: 5px;\n}\n\n.errorText {\n    color: #ffffff;\n    font-size: 14px;\n    margin-top: 10px;\n    background-color: #f73439;\n    padding: 12px 20px;\n    border-radius: 8px;\n    width: 100%;\n    max-width: 600px;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    box-shadow: 0 2px 4px rgba(247, 52, 57, 0.2);\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.confirmationDiv{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2\n}\n\n.confirmationWrapper{\n    background-color: #fff;\n    border-radius: 20px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n.confirmationItemDiv{\n    width: 80%;\n}\n\n.loader{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2\n}\n\n.loaderDiv{\n    background-color: #fff;\n    border-radius: 20px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n}\n\n.fetchingText{\n    margin-top: 50px;\n    margin-bottom: 30px;\n    font-size: 14px;\n    color: #040404CC;\n    font-family: 'CircularXXWeb-Medium';\n}\n\n.loadingText{\n    color: #e78a00;\n    font-size: 12px;\n    text-align: center;\n}\n\n\n@media screen and (max-width: 768px) {\n    .MainContainer {\n        padding: 15px;\n    }\n\n    .topPanText {\n        font-size: 16px;\n    }\n\n    .clockText {\n        font-size: 12px;\n    }\n\n    .tab {\n        padding: 8px 15px;\n        font-size: 14px;\n    }\n\n    .EnterYourPan {\n        font-size: 14px;\n        margin-bottom: 40px;\n        text-align: center;\n        padding: 0 5px;\n    }\n\n    .ListDiv {\n        padding: 0 5%;\n        margin-top: 30px;\n    }\n\n    .consentDiv {\n        width: 100%;\n        font-size: 11px;\n        padding: 15px;\n        margin: 20px auto;\n    }\n\n    .verifyButton {\n        width: 90%;\n        max-width: 300px;\n    }\n\n    .shieldDiv {\n        padding: 0 15px;\n        margin-top: 30px;\n    }\n\n    .shieldText {\n        font-size: 13px;\n    }\n\n    .panImage {\n        width: 100%;\n        max-width: 400px;\n        height: auto;\n        margin-left: -15px;\n        margin-top: 0;\n    }\n\n    .uploadSection {\n        flex-direction: column;\n        align-items: center;\n        gap: 30px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .formRow {\n        flex-direction: column;\n        gap: 10px;\n    }\n}\n\n.errorBanner {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background-color: #fef2f2;\n    border: 1.5px solid #f87171;\n    color: #dc2626;\n    padding: 12px 16px;\n    border-radius: 10px;\n    margin: 15px 0 5px 0;\n    font-size: 13.5px;\n    font-weight: 600;\n    line-height: 1.4;\n    text-align: left;\n    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContainer": `DigiLockerLanding_MainContainer__CZpGv`,
	"MainWrapper": `DigiLockerLanding_MainWrapper__LJoLi`,
	"topPANDiv": `DigiLockerLanding_topPANDiv__G2lga`,
	"topPanText": `DigiLockerLanding_topPanText__DZsMi`,
	"topClockDiv": `DigiLockerLanding_topClockDiv__0+OAK`,
	"clockIcon": `DigiLockerLanding_clockIcon__SGVCM`,
	"clockText": `DigiLockerLanding_clockText__WqAFa`,
	"tabsContainer": `DigiLockerLanding_tabsContainer__hRe-W`,
	"tab": `DigiLockerLanding_tab__OnW2d`,
	"activeTab": `DigiLockerLanding_activeTab__tEDKC`,
	"tabContent": `DigiLockerLanding_tabContent__fnuZ1`,
	"panDemoDiv": `DigiLockerLanding_panDemoDiv__XUkWK`,
	"EnterYourPan": `DigiLockerLanding_EnterYourPan__D1x2y`,
	"panImage": `DigiLockerLanding_panImage__O4yAY`,
	"SamplePANText": `DigiLockerLanding_SamplePANText__MjGt0`,
	"ListDiv": `DigiLockerLanding_ListDiv__Fs5Cn`,
	"ListItem": `DigiLockerLanding_ListItem__dWM8x`,
	"consentDiv": `DigiLockerLanding_consentDiv__2gxGO`,
	"shieldDiv": `DigiLockerLanding_shieldDiv__ditCr`,
	"shieldText": `DigiLockerLanding_shieldText__wkaYy`,
	"Line": `DigiLockerLanding_Line__sFD4P`,
	"verifyButton": `DigiLockerLanding_verifyButton__SUkrs`,
	"addressFormContainer": `DigiLockerLanding_addressFormContainer__tGyF0`,
	"addressHeading": `DigiLockerLanding_addressHeading__1dp53`,
	"formGroup": `DigiLockerLanding_formGroup__38QSX`,
	"formLabel": `DigiLockerLanding_formLabel__UNLYd`,
	"formInput": `DigiLockerLanding_formInput__dB8FR`,
	"formRow": `DigiLockerLanding_formRow__pgOXK`,
	"uploadButton": `DigiLockerLanding_uploadButton__fr9ue`,
	"documentUploadContainer": `DigiLockerLanding_documentUploadContainer__kH0Dh`,
	"uploadSection": `DigiLockerLanding_uploadSection__rQusV`,
	"previewContainer": `DigiLockerLanding_previewContainer__GclU9`,
	"previewImage": `DigiLockerLanding_previewImage__BsQF5`,
	"uploadNote": `DigiLockerLanding_uploadNote__IZy6t`,
	"errorText": `DigiLockerLanding_errorText__k5ioc`,
	"fadeIn": `DigiLockerLanding_fadeIn__rF0aM`,
	"confirmationDiv": `DigiLockerLanding_confirmationDiv__kcCSb`,
	"confirmationWrapper": `DigiLockerLanding_confirmationWrapper__SGuc6`,
	"confirmationItemDiv": `DigiLockerLanding_confirmationItemDiv__EEr9P`,
	"loader": `DigiLockerLanding_loader__h5V0J`,
	"loaderDiv": `DigiLockerLanding_loaderDiv__huUei`,
	"fetchingText": `DigiLockerLanding_fetchingText__r+P6F`,
	"loadingText": `DigiLockerLanding_loadingText__Zlsnb`,
	"errorBanner": `DigiLockerLanding_errorBanner__qCHV9`
};
export default ___CSS_LOADER_EXPORT___;
